import React, { useState } from 'react';
import style from './NewsLetter.module.css';
import { ValidateEmail } from '../../utils/ValidateEmail';
import axios from 'axios';
import { toast } from 'react-toastify';

const NewsLetter = () => {
  const [text, setText] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (ValidateEmail(text)) {
      await axios
        .post(
          '/newsletter',
          { email: text },
          {
            headers: { 'Access-Control-Allow-Origin': '*' },
            withCredentials: true,
          }
        )
        .then((res) => {
          setText('');
          toast.success(res.data.message);
        });
    }
  };

  return (
    <div className={style.NewsLetter}>
      <div className={style.Left}>
        <p>
          Hackers subscribed to our newsletter are <span>35.8%</span> more
          likely to earn a Bounty
        </p>
      </div>

      <div className={style.Right}>
        <input
          type='text'
          placeholder='Your email, Please'
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <span onClick={handleSubmit}>Prove It</span>
      </div>
    </div>
  );
};

export default NewsLetter;
